import React from "react";
import styles from "./ExposeMotifs.module.scss";

export const ExposeMotifs = ({ document, texte = null }) => {
	return (
		<div className={styles.container}>
			<div className={styles.header}>
				<div className={styles.title}>Exposé des motifs</div>
			</div>

			<div className={styles.content}>
				{texte || document.exposeMotifsTexte ? (
					<div className={styles.text}>
						{texte || document.exposeMotifsTexte}
					</div>
				) : (
					<i>Pas d'exposé des motifs</i>
				)}
			</div>
		</div>
	);
};
